import { Avatar, Tooltip } from '@mui/material';

interface TimelineAvatarProps {
  name?: string;
}

const getInitials = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
};

const TimelineAvatar = ({ name = '' }: TimelineAvatarProps) => (
  <Tooltip title={name}>
    <Avatar
      data-test="timeline-item-avatar"
      sx={{
        width: 20,
        height: 20,
        fontSize: 10,
        color: 'white',
        bgcolor: 'primary.main',
      }}
    >
      {getInitials(name)}
    </Avatar>
  </Tooltip>
);

export default TimelineAvatar;
